<template>
    <div>
        <div class>
            <Steps :active="1" align-center>
                <Step :title="$t('offering.offbase')" @click.native="on_click('offbaseAdd')" />
                <Step :title="$t('offering.offeringResources')"/>
                <Step :title="$t('offering.offconditionAdd')" @click.native="on_click('offconditionAdd')" />
                <Step :title="$t('offering.offnoticeAdd')" @click.native="on_click('offnoticeAdd')" />
                <Step :title="$t('offering.offpriceAdd')" @click.native="on_click('offpriceAdd')" />
                <Step :title="$t('offering.offinvestAdd')" @click.native="on_click('offinvestAdd')" />
                <Step :title="$t('offering.offabilityAdd')" @click.native="on_click('offabilityAdd')" />
            </Steps>
        </div>
        <br/>
        <div class='divMessage'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{ message }}</div>
        <br/>
        <el-card style="min-width:900px;" class="aui-card--fill" shadow="never">
            如需设置资源，请联系排课管理员。
        </el-card>
        <div>
            <el-row>
                <el-col :span="16">
                    <div class="grid-content" />
                </el-col>
            </el-row>
            <el-row  style="float:right; margin-bottom: 60px;">
                <el-col :span="16"><div class="grid-content" /></el-col>
                <el-button @click="btnSaveNextStep" type="primary">{{ $t("course.saveAndNext") }}</el-button>
                <el-button @click="sendSave"  type="primary">{{ $t("course.save") }}</el-button>
                <ZElButton @click="btnCancel" >{{ $t("course.cancel") }}</ZElButton>
            </el-row>
        </div>
    </div>
</template>

<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
// 例如：import 《组件名称》 from '《组件路径》';
// 基本信息   offbaseAdd
// 报名条件   offconditionAdd
// 报名通知   offnoticeAdd
// 价格相关   offpriceAdd
// 调查问卷   offinvestAdd
// 能力项设置 offabilityAdd
import Steps from '../../common/steps/index'
import Step from '../../common/steps/src/step'
import ZElButton from '../../common/button/index'
import offeringCourseds from '../offeringcommon/offeringCoursed'
import ResouceSelect from '@/components/rm/resouce-select/index'
import siteSelect from '@/components/learning/subordinate-site/offeringSite'
export default {
// import引入的组件需要注入到对象中才能使用
  components: { Steps, Step, ZElButton, offeringCourseds, 'resouce-select': ResouceSelect, 'subordinate-site': siteSelect },
  props: ['message', 'passOfferingId'],
  inject: ['toTop'],
  data () {return {} },
  // 监听属性 类似于data概念
  computed: {},
  // 监控data中的数据变化
  watch: {},
  // 生命周期 - 创建完成（可以访问当前this实例）
  created () {
    console.log('created')
  },
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted () {
    console.log('mounted')
  },
  beforeCreate () {
    console.log('beforeCreate')
  }, // 生命周期 - 创建之前
  beforeMount () {
    console.log('beforeMount')
  }, // 生命周期 - 挂载之前
  beforeUpdate () {
    console.log('beforeUpdate')
  }, // 生命周期 - 更新之前
  updated () {
    console.log('updated')
  }, // 生命周期 - 更新之后
  beforeDestroy () {
    console.log('beforeDestroy')
  }, // 生命周期 - 销毁之前
  destroyed () {
    console.log('destroyed')
  }, // 生命周期 - 销毁完成
  activated () {
    console.log('activated')
  },
  // 方法集合
  methods: {
    btnSaveNextStep () {
      console.log('editTO')
      this.sendMsg()
    },
    // 向父页面传递消息 跳转下一页面
    sendMsg () {
      this.toTop()
      this.$emit('onShowModer', 'offconditionsend')
    },
    // 向父页面传递消息 保存页面
    sendSave () {
      this.$emit('onShowModer', 'offnoticeSave')
      this.tabRemove()
      this.$router.push({
        name: 'learning-offering-offeringlist'
      })
    },
    // 取消按钮
    btnCancel () {
      this.tabRemove()
    },
    // 点击导航跳转页面
    on_click (e) {
      this.$confirm('离开本页将不保存当前正在编辑的数据, 确定离开? ', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$emit('onShowModer', e)
      }).catch((err) => {
        console.log(err)
      })
    },
    // 删除当前页面
    tabRemove () {
      let tabName = this.$store.state.contentTabsActiveName
      if (tabName === 'home') {
        return false
      }
      this.$store.state.contentTabs = this.$store.state.contentTabs.filter(item => item.name !== tabName)
      if (this.$store.state.contentTabs.length <= 0) {
        this.$store.state.sidebarMenuActiveName = this.$store.state.contentTabsActiveName = 'home'
        return false
      }
      // 当前选中tab被删除
      if (tabName === this.$store.state.contentTabsActiveName) {
        this.$router.push({ name: this.$store.state.contentTabs[this.$store.state.contentTabs.length - 1].name })
      }
    }
  }
}
</script>
<style lang='scss' scoped>
  .div a{
    cursor: pointer;
  }
  .btnTrainer{background: none;}
  .btnTrainer:active {background: #ffffff;border-color: #ffffff;color: #ffffff;}
  .btnTrainer:focus {background: #ffffff;border-color: #ffffff;color: #ffffff;}
  .btnTrainer:hover {background: #ffffff;border-color: #ffffff;color: #ffffff;}
  .el-icon-trainer{
    background: url(../../../../../assets/img/learning/trainer.png) center no-repeat;
    background-size: cover;
  }
  .el-icon-trainer:before{
    content: "替";
    font-size: 16px;
    visibility: hidden;
  }
  .el-icon-room{
    background: url(../../../../../assets/img/learning/room.png) center no-repeat;
    background-size: cover;
  }
  .el-icon-room:before{
    content: "替";
    font-size: 16px;
    visibility: hidden;
  }
  .ax_default {
    font-family:'Arial Normal', 'Arial', sans-serif;
    font-weight:400;
    font-style:normal;
    font-size:13px;
    letter-spacing:normal;
    color:#333333;
    vertical-align:none;
    text-align:center;
    line-height:normal;
    text-transform:none;
  }
  #btnDiv_div {
    position:absolute;
    left:0px;
    top:0px;
    width:119px;
    height:36px;
    background:inherit;
    background-color:rgba(255, 255, 255, 1);
    box-sizing:border-box;
    border-width:1px;
    border-style:solid;
    border-color:rgba(221, 221, 221, 1);
    border-radius:4px;
    -moz-box-shadow:none;
    -webkit-box-shadow:none;
    box-shadow:none;
    font-family:'Arial Normal', 'Arial', sans-serif;
    font-weight:400;
    font-style:normal;
    color:#169BD5;
    text-align:right;
  }
  #btnDiv {
    border-width:0px;
    position:absolute;
    width:119px;
    height:36px;
    display:flex;
    font-family:'Arial Normal', 'Arial', sans-serif;
    font-weight:400;
    font-style:normal;
    color:#169BD5;
    text-align:right;
  }
  #btnDiv .text {
    position:absolute;
    align-self:center;
    padding:8px 12px 8px 12px;
    box-sizing:border-box;
    width:100%;
  }
  #btnDiv_text {
    border-width:0px;
    word-wrap:break-word;
    text-transform:none;
  }
  #picDiv_img {
    border-width:0px;
    position:absolute;
    left:10px;
    top:6px;
    width:24px;
    height:24px;
  }
  #picDiv {
    border-width:0px;
    position:absolute;
    width:24px;
    height:24px;
    display:flex;
  }
  #picDiv .text {
    position:absolute;
    align-self:center;
    padding:2px 2px 2px 2px;
    box-sizing:border-box;
    width:100%;
  }
  #picDiv_text {
    border-width:0px;
    word-wrap:break-word;
    text-transform:none;
    visibility:hidden;
  }
  .grid-content {
      border-radius: 4px;
      min-height: 36px;
  }
</style>
